import { UNAVAILABLE_PACKAGES } from "goi_common";
import { PremiumMemberShipPackage } from "./일반장프리미엄";

export const 가족장프리미엄2025: PremiumMemberShipPackage<"가족장 프리미엄"> = {
  type: "가족장 프리미엄",
  packageKey: UNAVAILABLE_PACKAGES.FIRST30.productKey,
  description: `고급 용품으로 업그레이드된 가족장 서비스로 
가입비 30만 원으로 할인가를 보장받으실 수 있어요.`,
  backgroundColor: "#29353F",
  mainColor: "#FF8F39",
  subColor: "#FEFAF6",
  summary: `좋은 용품의 소규모 장례`,
  recommendationText: `<b>유가족 중심의 소규모 장례</b>를 희망하는 분께 추천드립니다.
  최고급 용품으로 구성되어 프리미엄 장례 서비스를 제공해드립니다.
  장례를 치르기에 적합한 인력, 용품, 차량이 모두 포함되어있습니다.
  `,
  imageSrc: "platform/service/service_family_premium.png",
  주의사항: `30만원 납입시 추가 10% 할인
  <br />서비스 이용 당해 년도 프리미엄 패키지 10%할인 적용
  <br />(가입비 30만원 + 패키지 302만 1천원(2025년내 이용 예시))`,
  정상가: 489,
  가격: 369,
  최종할인가: 332,
  조문객: "50~100명",
  빈소: "30평 ~ 50평",
  접객도우미: "4명",
  "장례 용품": "고급형",
  "장의 차량": 1,
  details: [
    {
      key: "인력",
      contents: [
        {
          src: "platform/service/person1.png",
          title: "장례지도사",
          descriptions: "1인 3일",
          price: 600_000,
        },
        {
          src: "platform/service/person2.png",
          title: "염습상례사",
          descriptions: "1인 1일",
          price: 150_000,
        },
        {
          src: "platform/service/person3.png",
          title: "접객 도우미",
          descriptions: "4인 10시간",
          price: 480_000,
        },
      ],
    },
    {
      key: "용품",
      contents: [
        {
          src: "platform/service/gwan0-2025.png",
          title: "0.6 오동관",
          descriptions: `화장용`,
          price: 200_000,
        },
        {
          src: "platform/service/sui2-2025.png",
          title: "고급 대마 가진수의",
          descriptions: `(대마 100%)`,
          price: 1_500_000,
          discountPrice: 500_000,
        },
        {
          src: "platform/service/ugol5.png",
          title: "이중 진공 유골함",
          descriptions: ``,
          price: 720_000,
          discountPrice: 520_000,
        },
        {
          src: "platform/service/6.png",
          title: "관 장식용 생화",
          descriptions: "고급 생화, 국화꽃",
          price: 200_000,
        },
        {
          src: "platform/service/5.png",
          title: "입관 수시 용품",
          descriptions: "20종(멧베 등)",
          price: 280_000,
        },
        {
          src: "platform/service/7.png",
          title: "빈소 용품",
          descriptions: "초, 향, 부의록 등",
          price: 0,
        },
        {
          src: "platform/service/sangbok_male.png",
          title: "남자 상복",
          descriptions: "3벌",
          price: 150_000,
        },
        {
          src: "platform/service/sangbok_female.png",
          title: "여자 상복",
          descriptions: "3벌",
          price: 60_000,
        },

        {
          src: "platform/service/sangbok.png",
          title: "상주 용품",
          descriptions: "완장, 리본 등",
          price: 0,
        },
      ],
    },
    {
      key: "차량",
      contents: [
        {
          src: "platform/service/ambulance.png",
          title: "앰뷸런스",
          descriptions: `관내 이송`,
          price: 100_000,
        },
        {
          src: "platform/service/bus.png",
          title: "45인승 장의버스",
          descriptions: `200km 왕복`,
          price: 450_000,
        },
      ],
    },
  ],
  extraDetails: [
    {
      key: "희망하시는 경우 용품을 변경할 수 있습니다",
      contents: {
        유골함: [
          {
            src: "platform/service/ugol3.png",
            title: "종교별 유골함",
            descriptions: "상세 품목 요청시 카탈로그 제공",
            price: 500_000,
            discountPrice: 450_000,
          },
        ],
        차량: [
          {
            src: "platform/service/limousine.png",
            title: "3일차 고인 이송 차량",
            descriptions: `리무진
                  (200km 초과시
                  km 당 2,000원 추가)`,
            price: 450_000,
          },
        ],
        매장용품: [
          {
            src: "platform/service/gwan1-2025.png",
            title: "매장용 관, 용품, 인력",
            descriptions: `오동나무 1.0관으로 변경(+10)
                횡대, 결관포 등 용품 추가(+12)
                유골함 공제(-52)
                `,
            price: -300_000,
          },
        ],
      },
      //  [
      //     {
      //       src: "platform/service/ugol3.png",
      //       title: "종교별 유골함",
      //       descriptions: "상세 품목 요청시 카탈로그 제공",
      //       price: 500_000,
      //       discountPrice: 450_000,
      //     },
      //     {
      //       src: "platform/service/limousine.png",
      //       title: "3일차 고인 이송 차량",
      //       descriptions: `리무진
      //       (200km 초과시
      //       km 당 2,000원 추가)`,
      //       price: 450_000,
      //     },
      //     {
      //       src: "platform/service/gwan1-2025.png",
      //       title: "매장용 관, 용품, 인력",
      //       descriptions: `오동나무 1.0관으로 변경(+10)
      //       횡대, 결관포 등 용품 추가(+12)
      //       유골함 공제(-52)
      //       `,
      //       price: -300_000,
      //     },
      //   ],
    },
  ],
  steps: [
    [
      {
        src: "images/service/first_1.png",
        title: "고인 이송",
        description: "임종 후, 병원이나 장례식장으로 이송합니다.",
      },
      {
        src: "images/service/first_2.png",
        title: "고인 안치",
        description: "고인의 옷과 몸을 바르게 하는 수시 후, 고인을 장례식장에 안치합니다.",
      },
      {
        src: "images/service/first_3.png",
        title: "빈소 설치",
        description: "조문객의 인원과, 가족수에 맞는 빈소를 설치합니다.",
      },
      {
        src: "images/service/first_4.png",
        title: "화장장 예약",
        description: "3일차에 화장이 가능하도록 장례지도사님께서 미리 화장장 예약을 진행합니다.",
      },
      {
        src: "images/service/first_5.png",
        title: "부고 문자 발송",
        description: "꼭 필요한 정보가 누락되지 않도록 부고문자를 작성해드립니다.",
      },
    ],
    [
      {
        src: "images/service/second_1.png",
        title: "염습",
        description: "고인의 몸을 깨끗이 한 후, 수의를 입힙니다. 입관 전에 거치는 절차입니다.",
      },
      {
        src: "images/service/second_2.png",
        title: "입관식",
        description:
          "염습 후 고인의 마지막 모습을 보면서 애도할 수 있는 입관식을 진행합니다.\n" +
          "(고인의 종교에 따라 종교지도사 참여 가능합니다.)",
      },
      {
        src: "images/service/second_3.png",
        title: "성복",
        description:
          "정식으로 상복을 입는 절차입니다. 요즘에는 1일차에 바로 상복을 입지만, 입관 후 정식으로 완장/머리핀을 착용하게 됩니다.",
      },
      {
        src: "images/service/second_4.png",
        title: "성복제",
        description: "성복 후 고인께 제례를 드리는 절차로 종교에 따라 생략 혹은 대체가 가능합니다.",
      },
      {
        src: "images/service/second_5.png",
        title: "조문",
        description:
          "일반적으로 2일차에 조문객이 가장 많이 옵니다. 상황에 맞게 인력을 배치해드립니다.",
      },
    ],
    [
      {
        src: "images/service/third_1.png",
        title: "발인",
        description: "관이 장례식장을 떠나는 절차이며, 관을 버스나 리무진까지 옮깁니다.",
      },
      {
        src: "images/service/third_2.png",
        title: "운구",
        description: "고인을 장지까지 옮기는 절차이며, 버스나 리무진으로 이송합니다.",
      },
      {
        src: "images/service/third_3.png",
        title: "화장 / 유골 안치",
        description: "예약한 시간에 화장 후 안치시설로 옮깁니다.",
      },
      {
        src: "images/service/third_4.png",
        title: "사후 행정",
        description: "사망신고, 유족연금, 상속신고 등 법적, 행정적 안내를 도와드립니다.",
      },
    ],
  ],
  deductions: [
    "패키지에 포함되어 있는 품목 미사용시 금액을 100% 공제해 드립니다.",
    "용품/차량이 아닌 인력 서비스(장례지도사, 염습상례사)는 장례식 절차에 빠질 수 없는 요소이기 때문에 공제가 불가능합니다.",
  ],
  extra: [
    "4일장, 5일장 등 3일장에서 일정이 길어질 경우 장례지도사 서비스 비용이 1일당 15만원 추가됩니다.",
    "정해진 거리를 초과하여 장의 차량 및 앰뷸런스를 이용할 경우 차량 서비스 비용이 1km 당 2,000원 추가됩니다",
    "관외 이동시 도로교통비가 발생할 경우 해당 비용을 청구합니다.",
    "사고사의 경우 염습에 특수처리가 필요하여 20만원의 비용이 추가됩니다.",
    "매장의 경우 매장 전용 관, 수의, 횡대 등의 물품이 필요하여 추가 비용이 발생합니다.",
    "출동 후 서비스 이용을 취소하실 경우 25만원의 취소 위약금이 발생합니다.",
  ],
};
